import React, { useEffect, useState } from "react";
import { NavigateFunction, createBrowserRouter, RouterProvider, RouteObject, Navigate } from "react-router-dom";
import { GlobalMenu_Router, SystemMenu_Router, focus_viewMenu_Router, ToolsMenu_Router, Global_Nav, System_Nav, focus_view_Nav, Tools_Nav } from "./Routers";
import { Def, Login, UserInformations, Error50X} from "../Containers"
import { DefLayout, FullViewPanelLayout, FocusViewPanelLayout, ToolspanelLayout } from "./Layout";
import { RootPages, GlobalMenu_Pages, SystemMenu_Pages, focus_viewMenu_Pages, ToolsMenu_Pages } from "./pages"
import { useUser } from "../Services";
import { useAppSelector } from "../Store";
import { setStates } from "../Store/StateHandlers/active-slice";
import { IS_CLOUD } from "../app";
import { AicoConnectionProvider } from "../Components";

/* eslint-disable */
export type Pages = RootPages | GlobalMenu_Pages | SystemMenu_Pages | ToolsMenu_Pages | focus_viewMenu_Pages
export const Pages = {
  ...RootPages,
  ...GlobalMenu_Pages,
  ...SystemMenu_Pages,
  ...ToolsMenu_Pages,
  ...focus_viewMenu_Pages
}
/* eslint-enable */

export function hardNavigateToLogin () {
  const tempLink = document.createElement('a');
  tempLink.href = window.location.origin + Pages.login;
  tempLink.rel = 'noreferrer';
  tempLink.click();
}

function ProtectedRoute({ userToken, activeFarm, pageNavigation, children }: { userToken?: string, activeFarm?: string, pageNavigation: GlobalMenu_Pages | focus_viewMenu_Pages, children: React.ReactNode }) {

  // The rootRouter will not be updated when navigation initially on siteList
  const reduxStateFarm = useAppSelector(({activeData}) => activeData.farm);
  const userFarms = useAppSelector(({graphQlData}) => graphQlData.user.UserFarms);

  let currentUserFarm = userFarms?.find((farm) => farm.domain === reduxStateFarm);
  if (!currentUserFarm){
    currentUserFarm = userFarms?.find((farm) => farm.domain === activeFarm);
  }

  if (!userToken || (!activeFarm && !reduxStateFarm) || (currentUserFarm !== undefined && currentUserFarm.legacy) || IS_CLOUD) {
    hardNavigateToLogin();
    return;
    // return <Navigate to={RootPages.login} state={{ selected: pageNavigation }} />;
  }
  return <>{children}</>;
}

function AdminOnlyRoute({
  pageNavigation,
  children,
  userToken,
}: {
  pageNavigation: GlobalMenu_Pages | focus_viewMenu_Pages | ToolsMenu_Pages;
  children: React.ReactNode;
  userToken?: string;
}) {
  const adminInfo = useAppSelector(({ graphQlData }) => graphQlData.user.AdminInfo);
  const { getAdminInfo } = useUser();
  const [loading, setLoading] = useState(adminInfo ? false : true);

  useEffect(() => {
    let mounted = true;

    const fetch = async () => {
      if (!adminInfo && userToken) {
        await getAdminInfo();
      }
      if (mounted) setLoading(false);
    };

    fetch();
    return () => {
      mounted = false;
    };
  }, [adminInfo, userToken, getAdminInfo]);

  //TODO: add a loading spinner?
  if (loading) return <>loading...</>;
  if (!userToken || !adminInfo || !IS_CLOUD) {
    hardNavigateToLogin();
    return
    // return <Navigate to={RootPages.login} state={{ selected: pageNavigation }} />;
  }

  return <>{children}</>;
}

const rootRouter = (userToken?:string, activeFarm?:string) => [
  { 
    path: "/",
    element: <DefLayout/>,
    //loader: rootLoader,  //#prefetch loader #See https://reactrouter.com/en/main/route/loader
    children: [
      {index:true, element: <Def />}
    ],
  },
  {
    path: RootPages.login,
    Component: Login
  },
  {
    path: RootPages.userInformations,
    Component: UserInformations
  },
  {
    path: RootPages.error,
    Component: Error50X
  },
  {
    element: (
      <AdminOnlyRoute pageNavigation={Pages.aico} userToken={userToken}>
        <AicoConnectionProvider> {/*TODO(MTH): dont wrap here? */}
          <ToolspanelLayout />
        </AicoConnectionProvider>
      </AdminOnlyRoute>
    ),
    children: [ 
      ...ToolsMenu_Router
   ]
  },
  {
    element: (
      <ProtectedRoute userToken={userToken} activeFarm={activeFarm} pageNavigation={Pages.kpi}>
        <FullViewPanelLayout/>
      </ProtectedRoute>
    ),
    children: [ 
      ...GlobalMenu_Router,
      ...SystemMenu_Router
    ]
  },
  {
    element: (
      <ProtectedRoute userToken={userToken} activeFarm={activeFarm} pageNavigation={Pages.op_operations}>
        <FocusViewPanelLayout/>
      </ProtectedRoute>
    ),
    children: [ 
      ...focus_viewMenu_Router
    ]
  },
  {
    path:'*',
    element: (<Navigate to="/" />)
  }
] as RouteObject[]

export const NavigationFunction = ({ Navigator, navigation_page, navigation_tab, replace = false, navArgs, dispatch, currentDomain }: { Navigator: NavigateFunction; navigation_page: Pages; navigation_tab?: Pages; replace?: boolean; navArgs?: object; dispatch?: any; currentDomain?: string; }) => {
  switch (navigation_page) {
    case RootPages.def:
      if (dispatch) {
        dispatch(setStates({ type: "farm", farm: undefined }));
      }
      Navigator(RootPages.def, {replace:replace, state:navArgs})
    break
    case RootPages.login:
      hardNavigateToLogin() 
      //Navigator(RootPages.login, {state: navArgs})
    break
    case RootPages.userInformations:
      Navigator(RootPages.userInformations)
    break
    default:
      if (Object.values(GlobalMenu_Pages).includes(navigation_page as any)) {
        Global_Nav(Navigator, navigation_page as GlobalMenu_Pages, navigation_tab as GlobalMenu_Pages, navArgs, currentDomain)
      }
      else if (Object.values(SystemMenu_Pages).includes(navigation_page as any)) {
        System_Nav(Navigator, navigation_page as SystemMenu_Pages, navigation_tab as SystemMenu_Pages, navArgs, currentDomain)
      }
      else if (Object.values(ToolsMenu_Pages).includes(navigation_page as any)) {
        Tools_Nav(Navigator, navigation_page as ToolsMenu_Pages, navigation_tab as ToolsMenu_Pages, currentDomain)
      }      
      else if (Object.values(focus_viewMenu_Pages).includes(navigation_page as any)) {
        focus_view_Nav(Navigator, navigation_page as focus_viewMenu_Pages, currentDomain)
      }
      else {
        console.error("Error page not found (404)???", navigation_page, navigation_tab)
      }
  }
}

export default function Root() {
  const { userToken } = useUser()
  const activeFarm = useAppSelector<string|undefined>(({activeData}) => activeData?.farm)

  return(
    <RouterProvider router={createBrowserRouter(rootRouter(userToken, activeFarm), {future: {
      v7_relativeSplatPath: true,
    }})} />
  )
}
